module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1522-1203f12cc5726475a5ed06aa29744307.png";